import { alpha, Box, Container } from "@mui/material";
import AccessMessagePage from "components/layout/AccessMessagePage";
import { Footer } from "components/layout/Footer";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router";
import { selectDistrictData } from "store/slices";
import { isValidValue } from "utils/validation";
import { useTranslation } from "react-i18next";
import PageSuspense from "../PageSuspense";

const MainLayout = () => {
  const { t } = useTranslation("layout");
  const { deletedAt: district_deletedAt } = useSelector(selectDistrictData);
  const footerSidebar = useMemo(() => <Footer />, []);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {isValidValue(district_deletedAt) ? (
        <AccessMessagePage msg={t("thisDistrictIsDeactivatedPlease2")} />
      ) : (
        <Box sx={{ display: "flex", flexGrow: 1 }}>
          <Box
            component="main"
            sx={(theme) => ({
              flexGrow: 1,
              backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
              overflowY: "auto",
              height:
                "calc(((1 - var(--template-frame-height, 0))* 100dvh) - 60px)",
              padding: "24px 24px 20px",
            })}
          >
            <Container
              sx={{ overflow: "none", height: "100%", position: "relative" }}
            >
              <PageSuspense><Outlet /></PageSuspense>
            </Container>
          </Box>
          {footerSidebar}
        </Box>
      )}
    </Box>
  );
};

export default MainLayout;
